export default __webpack_public_path__ + "static/media/List-documentation.3b6a1164.md";